var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h1", { staticClass: "head-title" }, [
        _vm._v("\n        " + _vm._s(_vm.generateHeadline()) + "\n    "),
      ]),
      _vm._v(" "),
      _vm.show_htoh_image
        ? _c("div", { key: "match-image", staticClass: "si-row" }, [
            _c("div", { staticClass: "si-box si-gallery" }, [
              _c("div", { staticClass: "si-content-wrp" }, [
                _c("img", {
                  staticClass: "si-img",
                  attrs: {
                    loading: "lazy",
                    src: _vm.match_image + "?w=" + _vm.image_compression_width,
                    title: _vm.generateMatchTitle(),
                    alt: _vm.generateMatchTitle(),
                  },
                }),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("no-list", {
        attrs: { translations: _vm.translations, toShow: "no_feed" },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }